var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(50 296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.891 298.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6,31.374a.759.759,0,0,0-.758.783V42.846H21.463V38.481a.762.762,0,0,0-.731-.767H16.844a.778.778,0,0,0-.772.767v4.365H10.708V32.511a.745.745,0,1,0-1.489,0V43.628a.749.749,0,0,0,.731.755h6.895a.749.749,0,0,0,.731-.755V39.263h2.4v4.365a.754.754,0,0,0,.758.755H27.6a.749.749,0,0,0,.731-.755V32.157A.754.754,0,0,0,27.6,31.374Z",
    transform: "translate(-5.402 -18.955)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.43,13.77l-6.035-6.2V3.348a.773.773,0,0,0-.779-.78.756.756,0,0,0-.737.78V6.023L13.9.9A.724.724,0,0,0,13.386.66.748.748,0,0,0,12.844.9L.342,13.685a.743.743,0,0,0,0,1.08.706.706,0,0,0,1.057,0L13.386,2.538,25.346,14.88a.729.729,0,0,0,.542.2.829.829,0,0,0,.542-.2A.82.82,0,0,0,26.43,13.77Z",
    transform: "translate(0 0)",
    fill: "#006"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHouse);
export default __webpack_public_path__ + "static/media/icon-house.1fcc99bfc6d36f0ae453e87d151f7294.svg";
export { ForwardRef as ReactComponent };